import { Component, Inject } from '@angular/core';
import { PagerService } from '../../services/shared/pager.service';
import { BrandService } from '../../services/brand/brand.service';
import { Brand } from '../../models/brand/brand-model';
import { UtilitiesService } from '../../services/shared/utilities.service';
import { ToastsManager } from 'ng2-toastr';
import { RolePermissionService } from '../../services/role/role-permission.service';
import { Router, ActivatedRoute } from '@angular/router';
@Component({
  selector: 'app-brand-list',
  templateUrl: './brand-list.component.html',
  styleUrls: ['./brand-list.component.scss']
})
/** Brand-List component*/
export class BrandListComponent {
  public brandList: Brand[];
  // pager object
  pager: any = {};
  searchQuery: string;
  //pageSize: number;
  // paged items
  pagedItems: any[];
  filteredItems: any[];
  //public rowsOnPage: number = 10;
  public arrRowsPerPage: number[];
  public isDeleteAllowed: boolean = false;
  public isEditAllowed: boolean = false;
  public isCreateAllowed: boolean = false;
  public rowsPerPage: number = 10;
  public pagenumber: number;
  public totalRecord: number;
  public currentPage: number = 1;
  public searchKeyword: string;
  public showBoundaryLinks: boolean;
  /** coupons-list ctor */
  constructor(private readonly brandsService: BrandService,
    private readonly utilitiesService: UtilitiesService,
    public toastr: ToastsManager,
    private readonly pagerService: PagerService, private readonly router: Router, private readonly rolePermissionService: RolePermissionService) {
    this.rolePermissionService.GetRolePermissions("brand").subscribe(
      data => {
        if (data != null) {

          var create = data.filter(function (element) {
            return (element.action == "create");
          });
          var list = data.filter(function (element) {
            return (element.action == "list");
          });

          var deletePermission = data.filter(function (element) {
            return (element.action == "delete");
          });

          var edit = data.filter(function (element) {
            return (element.action == "edit");
          });

          if (create.length > 0)
            this.isCreateAllowed = true;

          if (edit.length > 0)
            this.isEditAllowed = true;

          if (deletePermission.length > 0)
            this.isDeleteAllowed = true;
          if (list.length > 0) {
            this.getbrands();
            //this.pageSize = this.rowsOnPage;
            this.currentPage = 1;
            this.GetRowsPerPageList();
          }
          else {
            this.router.navigate(["/"]);
          }
        }
        else {
          this.router.navigate(["/"]);
        }
      }
    )
    this.pagenumber = 0;
    //this.rowsPerPage = this.rowsOnPage;
    this.totalRecord = 0;
    this.searchKeyword = "";
    this.showBoundaryLinks = true;
  }


  deleteBrand(id) {

    var ans = confirm("Are you sure to delete this Brand?");
    if (ans) {
      if (this.brandsService.deletebrand(id)) {
        this.toastr.success('Brand has been Deleted.', 'Success');
        this.getbrands();
      }
      ;
      // setTimeout(, 1000);
    }
  }
  getbrands() {
    this.brandsService.getBrandList(this.searchKeyword, this.pagenumber, this.rowsPerPage).subscribe(
      data => {
        this.brandList = data
        this.filteredItems = data;
        
        if (data.length>0)
          this.totalRecord = data[0].totalRecords;
      }

    )
  }
  setPage(page: number) {

    // get pager object from service
    this.pager = this.pagerService.getPager(this.brandList.length, page, this.rowsPerPage);

    // get current page of items
    this.pagedItems = this.brandList.slice(this.pager.startIndex, this.pager.endIndex + 1);
  }
  // Populate the row per page list
  GetRowsPerPageList() {
    this.arrRowsPerPage = this.utilitiesService.GetRowsPerPageList();
    this.rowsPerPage = this.arrRowsPerPage[0];
  }

  PageSizeChange() {
    this.pagenumber = 0;
    //this.rowsPerPage = this.rowsOnPage;
    //setTimeout(function () {
      this.currentPage = 1;
      this.getbrands();
    //}, 1000);

  }

  // Search the Grid
  onSearch(searchText: string) {
    
    this.pagenumber = 0;
    this.currentPage = 1;
    //this.rowsPerPage = this.rowsOnPage;
    this.searchKeyword = searchText;
    this.getbrands();
    //if (searchText != "") {
    //  this.filteredItems = this.utilitiesService.GetSearchedResult(this.brandList, searchText);

    //} else {
    //  this.filteredItems = this.brandList;
    //}
  }

  PageChanged($event) {
    this.pagenumber = ($event.page) - 1;
    this.currentPage = ($event.page);
    this.rowsPerPage = $event.itemsPerPage;

    this.getbrands();
  }
}



// WEBPACK FOOTER //
// ./src/app/brand/brand-list/brand-list.component.ts